import React from "react";
import { cn } from "../Libs/Utils/utils";

export interface OutletHeadingProps
  extends React.ComponentPropsWithoutRef<"h4"> {}

const OutletHeading = React.forwardRef<HTMLHeadingElement, OutletHeadingProps>(
  ({ className, children, ...props }, ref) => (
    <h4
      ref={ref}
      className={cn("text-primary text-3xl font-bold", className)}
      {...props}
    >
      {children}
    </h4>
  )
);
OutletHeading.displayName = "OutletHeading";

export interface OutletSubHeadingProps
  extends React.ComponentPropsWithoutRef<"h6"> {}

const OutletSubHeading = React.forwardRef<
  HTMLHeadingElement,
  OutletSubHeadingProps
>(({ className, children, ...props }, ref) => (
  <h6 ref={ref} className={cn("text-xl font-medium", className)} {...props}>
    {children}
  </h6>
));
OutletSubHeading.displayName = "OutletSubHeading";

export { OutletHeading, OutletSubHeading };
